import { Component, OnInit} from '@angular/core';
import { CallbackRequest } from 'app/models/admin.model';
import { AlertsService } from 'app/ui-components/alerts/alerts.service';
import { AdminService } from 'app/services/admin.service';
import { ActivatedRoute } from '@angular/router';
import { UserService } from 'app/users/user.service';
import { environment } from 'environments/environment';
import { AuthService, Passport } from 'app/services/auth.service';
import { OrderService } from 'app/services/order.service';
import * as uuid from 'uuid';
import { finalize } from 'rxjs';
@Component({
  selector: 'app-admin-callback',
  templateUrl: './admin-callback.component.html'
})

export class AdminCallbackComponent implements OnInit {

  tokenId!: string;
  customerNumber!: string;
  hasError: boolean = false;

  constructor(
    private aRoute: ActivatedRoute,
    private alertService: AlertsService,
    private adminService: AdminService,
    private userService: UserService,
    private authService: AuthService
  ) {}

  ngOnInit() {
    let token: Passport  = {
      id: uuid.v4(),
      userFlow: 'admin'
    }
    if(typeof this.userService.profile !== "undefined") {
      token['customerNumber'] = this.userService.profile.customerNumber;
    } else {
      token['customerNumber'] = '';
    }
    this.authService.getToken(token)
         .pipe(
            finalize(() => {
              console.log (`!!! manageAdmins profile ${JSON.stringify(this.userService.profile)}`);
                  //receive token from url
                this.aRoute.queryParams.subscribe(params => {
                  this.tokenId = params['tokenId'];
                });

                this.customerNumber = this.userService.profile.customerNumber;
                if(this.tokenId && this.customerNumber) {
                  //call participantCallback API
                  let request: CallbackRequest = {
                    CustomerNumber: this.customerNumber,
                    Token: this.tokenId
                  }
                  //console.log('Request '+ JSON.stringify(request))
                  this.adminService.participantCallback(request).subscribe({
                    next: (data: any) => {
                      if(data) {
                        console.log('Participant Callback is successful, redirecting to '+environment.rbrvs)
                        //redirect to RBRVS page
                        window.location.href = environment.rbrvs;
                      } else {
                        this.alertService.displayError('Error occurred on activation!');
                        this.hasError = true;
                      }
                    },
                    error: err => {
                      this.alertService.displayError('Error occurred on activation!');
                      console.log('Error occurred on activation ' + err.error.ErrorMessage)
                      this.hasError = true;
                    }
                  }); 

                } else {
                  console.log('Token or customer number not found')
                  this.alertService.displayError('Error occured!');
                  this.hasError = true;
                }
            }
          )
        )
        .subscribe();
    

  }
}
